import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import EntityTable from "../../common/tables/EntityTable";
import { EntityFieldTypes } from "@emberly/zenith-client";
import ResponsivePage from "../../common/core/ResponsivePage";
import config from "../../../config";
import { MissionEnumsLists } from "../../../common/constants";

export default function ServiceVehicleRegister() {
  const { t } = useTranslation();

  const columns = useMemo(() => {
    return [
      {
        field: "title",
        headerName: t("serviceVehicle:fieldTitle"),
        flex: 1,
        minWidth: 80,
      },
      {
        field: "active",
        headerName: t("serviceVehicle:fieldActive"),
        valueFormatter: (value) => t(value ? "serviceVehicle:fieldActiveLabelTrue" : "serviceVehicle:fieldActiveLabelFalse"),
        flex: 0.5,
        minWidth: 80,
      },
      {
        field: "driver",
        headerName: t("serviceVehicle:fieldDriver"),
        valueGetter: (_, row) => row.driver?.name || "-",
        flex: 1,
        minWidth: 120,
      },
      {
        field: "description",
        headerName: t("serviceVehicle:fieldDescription"),
        flex: 1,
        minWidth: 120,
      },
      {
        field: "weight",
        type: "number",
        headerName: t("serviceVehicle:fieldWeight"),
        flex: 0.5,
        minWidth: 80,
      },
      {
        field: "width",
        type: "number",
        headerName: t("serviceVehicle:fieldWidth"),
        flex: 0.5,
        minWidth: 80,
      },
      {
        field: "height",
        type: "number",
        headerName: t("serviceVehicle:fieldHeight"),
        flex: 0.5,
        minWidth: 80,
      },
      {
        field: "length",
        type: "number",
        headerName: t("serviceVehicle:fieldLength"),
        flex: 0.5,
        minWidth: 80,
      },
      {
        field: "fuel",
        type: "singleSelect",
        headerName: t("serviceVehicle:fieldFuel"),
        flex: 0.75,
        minWidth: 100,
        valueFormatter: (value) => t(`mission:enums:fuelType:${MissionEnumsLists.FuelType[value]}`),
        valueOptions: MissionEnumsLists.FuelType.map((_, value) => ({
          value,
          label: t(`mission:enums:fuelType:${MissionEnumsLists.FuelType[value]}`),
        })).filter(t => !!t.label)
      },
      {
        field: "emissionClass",
        type: "singleSelect",
        headerName: t("serviceVehicle:fieldEmissionClass"),
        flex: 0.75,
        minWidth: 100,
        valueFormatter: (value) => t(`mission:enums:emissionClass:${MissionEnumsLists.EmissionClass[value]}`),
        valueOptions: MissionEnumsLists.EmissionClass.map((_, value) => ({
          value,
          label: t(`mission:enums:emissionClass:${MissionEnumsLists.EmissionClass[value]}`),
        })).filter(t => !!t.label)
      },
    ]
  }, [t]);

  const fields = useMemo(() => [
    { name: t("serviceVehicle:fieldTitle"), path: "title", type: EntityFieldTypes.String, required: true },
    { name: t("serviceVehicle:fieldActive"), path: "active", type: EntityFieldTypes.Boolean, labels: { true: t("serviceVehicle:fieldActiveLabelTrue"), false: t("serviceVehicle:fieldActiveLabelFalse") }, defaultValue: true },
    { name: t("serviceVehicle:fieldDescription"), path: "description", type: EntityFieldTypes.String },

    { name: t("serviceVehicle:fieldWeight"), path: "weight", dataType: "number", serialization: "number", type: EntityFieldTypes.String },
    { name: t("serviceVehicle:fieldWidth"), path: "width", dataType: "number", serialization: "number", type: EntityFieldTypes.String },
    { name: t("serviceVehicle:fieldHeight"), path: "height", dataType: "number", serialization: "number", type: EntityFieldTypes.String },
    { name: t("serviceVehicle:fieldLength"), path: "length", dataType: "number", serialization: "number", type: EntityFieldTypes.String },
    
    { name: t("serviceVehicle:fieldFuel"), path: "fuel", type: EntityFieldTypes.Enum, options: MissionEnumsLists.FuelType, translationPath: "mission:enums:fuelType" },
    { name: t("serviceVehicle:fieldEmissionClass"), path: "emissionClass", type: EntityFieldTypes.Enum, options: MissionEnumsLists.EmissionClass, translationPath: "mission:enums:emissionClass" },

  ], [t])

  return (
    <ResponsivePage
      title={t("serviceVehicle:title")}
      maxWidth={config.pageSize.large}
    >
      <EntityTable
        tableId="service_vehicles"
        type="ServiceVehicle"
        columns={columns}
        fields={fields}
        createTitle={t("serviceVehicle:create")}
        editTitle={t("serviceVehicle:edit")}
        emptyStateTitle={t("serviceVehicle:emptyStateTitle")}
        emptyStateDescription={t("serviceVehicle:emptyStateDescription")}
        createButton
      />
    </ResponsivePage>
  );
}



/*
   public double? Width { get; set; }

   public double? Height { get; set; }

   public double? Weight {  get; set; }

   public FuelEnum Fuel { get; set; }

   public EmissionClassEnum EmissionClass { get; set; }
*/